<template>
	<!--eslint-disable-->
	<v-container fluid grid-list-md>
		<v-toolbar class="elevation-5 mb-3">
			<v-btn icon @click="$router.go(-1)">
				<v-icon>arrow_back</v-icon>
			</v-btn>
			<v-toolbar-title v-if="$route.params.user_id">{{ form.name }}</v-toolbar-title>
			<v-toolbar-title v-else>New User</v-toolbar-title>
			<v-spacer></v-spacer>
      <remove-dialog v-if="!isArchive" :yes="() => archive()">
				<v-btn class="my-0" color="success" :ripple="false">Archive</v-btn>
			</remove-dialog>
			<v-btn v-if="!isArchive" class="my-0" color="success" @click="save">save</v-btn>
		</v-toolbar>
		<progress-bar></progress-bar>
		<v-layout row wrap>
			<v-flex xs12 sm4>
				<v-card>
					<v-card-text>
						<div class='sl_form_title'>
							<h3>Main info</h3>
						</div>
						<v-divider class='my-2'></v-divider>
						<v-text-field v-model="form.firstname" :error-messages="errorMessages('firstname')" label="Name"></v-text-field>
						<v-text-field v-model="form.lastname" :error-messages="errorMessages('lastname')" label="Last name"></v-text-field>
						<v-text-field v-model="form.email" :error-messages="errorMessages('email')" label="Email"></v-text-field>
						<v-text-field v-model="form.phone" :error-messages="errorMessages('phone')" label="Phone number"></v-text-field>
						<v-text-field v-model="form.password" :error-messages="errorMessages('password')" label="Password"></v-text-field>
						<v-text-field v-model="form.password_confirmation" label="Confirm password"></v-text-field>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs12 sm4>
				<v-card>
					<v-card-text>
						<div class='sl_form_title'>
							<h3>Instance</h3>
						</div>
						<v-divider class='my-2'></v-divider>
						<sl-extended-select
							label="Select instance"
							v-model="form.instances"
							:data="instances"
							:withOptions="false"
						/>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import * as mixins from '@/mixins'
import instances from '@/components/sl-extended-select'
import RestoreDialog from '@/components/restore'

export default {
	name: 'UsersFormPage',
	mixins: [mixins.errors, mixins.form, mixins.preloader, mixins.removable],
	data() {
		return {
			api: this.$api.users,
			selections: [],
			instances: [],
      isArchive: this.$route.params.isArchive,
			form: {
				firstname: '',
				lastname: '',
				email: '',
				phone: '',
				password: '',
				instances: [],
				password_confirmation: '',
			}
		}
	},
	methods: {
		getParams(id) {
			this.params = {
				id: id,
				archive: this.isArchive ? 1 : 0,
			}
		},
		addInstances() {
			this.selections.forEach(selection => {
				this.form.instances.push({...selection})
			})
		},
		getInstances() {
			let params = {
				unlimit: 1
			}
			return this.$api.instances.list(params).then(response => {
				this.instances = response.data
			})
		},
		remove(key, index) {
			this.form[key].splice(index, 1)
		},
		archive() {
			this.api.archive(this.$route.params.user_id).then(() => {
        this.remove(this.$route.params.user, this.$router.go(-1))
				this.$notify({
					group: 'success',
					type: 'success',
					text: 'The user has been moved to the archive.'
				}, () => {
					this.$notify({
						group: 'error',
						type: 'error',
						text: 'Something went wrong.'
					})
				})
			})
		},
    unzip() {
			this.api.unzip(this.$route.params.user_id).then(() => {
        this.remove(this.$route.params.user, this.$router.go(-1))
				this.$notify({
					group: 'success',
					type: 'success',
					text: 'The user has been restored.'
				}, () => {
					this.$notify({
						group: 'error',
						type: 'error',
						text: 'Something went wrong.'
					})
				})
			})
		}
	},
	components: {
		'sl-extended-select': instances,
    RestoreDialog
	},
	mounted() {
		if (this.$route.params.user_id > 0) {
      const isArchive = this.$route.query.archive;
			this.loadWithTrashed(this.$route.params.user_id, isArchive)
		}

		this.background(this.getInstances())
	}
}
</script>
